/**
 * A component that renders the UrbanFootprint logo
 *
 * @param {object} props - the component's props
 * @param {string} props.variant - the logo variant ('dark' or 'light')
 *
 * @returns {JSX.Element} - the logo component
 */
export default function Logo({ variant = 'dark' }) {
  return (
    <img
      src={
        variant === 'dark'
          ? 'https://urbanfootprint.com/wp-content/uploads/2023/06/logo-urban-footprint.svg'
          : 'https://urbanfootprint.com/wp-content/uploads/2023/06/logo-urban-footprint-light.svg'
      }
      alt="UrbanFootprint"
    />
  );
}
